import * as yup from 'yup';

export const dealerApiAccessInitialValues = {
  name: '',
};

export const DealerApiAccessSchemaYup = yup.object().shape({
  name: yup.string().trim().required('Name is required'),
});
